import { Component, inject } from '@angular/core';
import { ActivityProcessParametrizationService } from 'orchestrator';
import { ListService } from '@abp/ng.core';
import { ConfirmationService } from '@abp/ng.theme.shared';
import {
  ActivityProcessParametrizationCreateDto,
  ActivityProcessParametrizationDto,
  ActivityProcessParametrizationExcelDownloadDto,
  ActivityProcessParametrizationUpdateDto,
} from '../proxy/controlling/dtos/activity-process-parametrization';
import { ACTIVITYPROCESSPARAMETRIZATION_CONFIG, ACTIVITYPROCESSPARAMETRIZATION_FIELDS } from './activity-process-parametrization.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm, ZnHierarchicalViewComponent } from '@zendra/shared';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-activity-process-parametrization',
  imports: [
    CommonModule,
    CrudPage,
    GenericForm,
    ZnHierarchicalViewComponent
  ],
  providers: [ListService, ActivityProcessParametrizationService, ConfirmationService],
  templateUrl: './activity-process-parametrization.html',
  styleUrl: './activity-process-parametrization.scss',
})
export class ActivityProcessParametrization extends BaseHierarchicalCrudComponent<
  ActivityProcessParametrizationDto,
  ActivityProcessParametrizationCreateDto,
  ActivityProcessParametrizationUpdateDto,
  ActivityProcessParametrizationExcelDownloadDto
> {
  service = inject(ActivityProcessParametrizationService);
  config = ACTIVITYPROCESSPARAMETRIZATION_CONFIG;
  fields = ACTIVITYPROCESSPARAMETRIZATION_FIELDS;

  protected prepareUpdateDto(data: any, selected: ActivityProcessParametrizationDto): ActivityProcessParametrizationUpdateDto {
    return {
      useLevel: data.useLevel,
      isLiquidable: data.isLiquidable,
      isDirect: data.isDirect,
      processId: data.processId,
      activityGroupId: data.activityGroupId,
      internalOrderId: data.internalOrderId,
      currencyId: data.currencyId,
      activityId: data.activityId,
      paymentTypeId: data.paymentTypeId,
      unitOfMeasureId: data.unitOfMeasureId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'ActivityProcessParametrization';
  }
}
